module.exports = __webpack_public_path__ + "img/Symbol.f3987d01.svg";